export var DataCatalogType;
(function (DataCatalogType) {
    DataCatalogType["DATA_CATALOG_TYPE_GLUE_CATALOG"] = "GLUE_CATALOG";
    DataCatalogType["DATA_CATALOG_TYPE_BIGLAKE_CATALOG"] = "BIGLAKE_CATALOG";
    DataCatalogType["DATA_CATALOG_TYPE_ICEBERG_REST_CATALOG"] = "ICEBERG_REST_CATALOG";
})(DataCatalogType || (DataCatalogType = {}));
